import { inject, provideAppInitializer } from '@angular/core';

import { INSPECTION_NOTIFICATIONS } from '@inspections/models/inspection-notifications';
import { NotificationEntitiesService } from '@notifications/services/notification-entities.service';

export function registerInspectionNotifications(): Promise<void> {
  const notificationEntitiesService = inject(NotificationEntitiesService);

  notificationEntitiesService.registerEntities(INSPECTION_NOTIFICATIONS);

  return Promise.resolve();
}

export const INSPECTIONS_INITIALIZER = provideAppInitializer(() =>
  registerInspectionNotifications()
);
